const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/defs/icons.ts';
import { css } from '@emotion/css';
declare let require: any;
import _ from 'lodash';

export const Icon: { [key: string]: string } = {};

const configcontext = require.context('../../../../assets/fonts/font-icons', true, /^.*\.json/);
configcontext.keys().forEach((filename: string) => {
    _.forEach(configcontext(filename), (_value: string, key: string) => {
        if (key.startsWith('_')) {
            return;
        }
        const name = _.join(_.map(_.split(key, '-'), _.capitalize), '');
        Icon[name] = key;
    });
});

export const IconClass = Object.keys(Icon).reduce((accumulator: { [key: string]: string }, key) => {
    accumulator[key] = `icons8-${Icon[key]}`;
    return accumulator;
}, {});

export const iconSize = (size: number, unit: string = 'px') => {
    const sizeAndUnit = `${size}${unit}`;
    return css`
        // !important is required because otherwise the icon specific class overrides the line-height; all other
        // properties are just set to !important for good measure (just in case...) ...
        width: ${sizeAndUnit} !important;
        height: ${sizeAndUnit} !important;
        line-height: ${sizeAndUnit} !important;
        font-size: ${sizeAndUnit} !important;

        &:before {
            font-size: ${sizeAndUnit} !important;
        }
    `;
};
